import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

const SelectorPuerto = function ({ onSelect, puntos, val }) {
    return (
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
                Seleccione el punto de interés
            </InputLabel>
            <Select
                labelId="selector-punnto-interes"
                id="selector-puento-interes-id"
                label="Seleccione el punto de interés"
                value={val}
                defaultValue={
                    puntos && puntos.lenght > 0 ? puntos[0].value : null
                }
                onChange={(e) => {
                    if (!e) {
                        onSelect(-1, null)
                    } else {
                        onSelect(e.target.value)
                    }
                }}
            >
                {puntos.map((punto, i) => {
                    return (
                        <MenuItem key={i} value={punto.value}>
                            {punto.label}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

SelectorPuerto.propTypes = {
    puntos: PropTypes.array,
    onSelect: PropTypes.func,
    val: PropTypes.number,
}

export { SelectorPuerto as default }
